import { lazy } from 'react';
import { Navigate } from 'react-router';

// project imports
import Loadable from 'components/Loadable'
import DashboardLayout from '../layout/Dashboard';
import RequireVerified from '../auth/RequireVerified';
import AdminRoute from '../auth/AdminRoute';

// config
import projectConfig from '@/projectConfig';

// main
const MainPage = Loadable(lazy(() => import('pages/main/MainPage')));

// make appointment 
const MakeAppointmentPage = Loadable(lazy(() => import('pages/makeAppointment/MakeAppointmentPage')));
const AppointmentByDirectionPage = Loadable(lazy(() => import('pages/makeAppointment/children/AppointmentByDirectionPage')));
const FreeAppointmentPage = Loadable(lazy(() => import('pages/makeAppointment/children/FreeAppointmentPage')));

// medcard 
const MedCardPage = Loadable(lazy(() => import('pages/medCard/MedCardPage')));
const AnalysisResultPage = Loadable(lazy(() => import('pages/medCard/children/AnalysisResultPage')));
const HospitalizationsPage = Loadable(lazy(() => import('pages/medCard/children/HospitalizationPage')));  
const ResearchPage = Loadable(lazy(() => import('pages/medCard/children/ResearchPage')))
const ExaminationPage = Loadable(lazy(() => import('pages/medCard/children/ExaminationPage')))
const DirectionPage = Loadable(lazy(() => import('pages/medCard/children/DirectionPage')))
const RecipePage = Loadable(lazy(() => import('pages/medCard/children/RecipePage')))
const RecommendationsPage = Loadable(lazy(() => import('pages/medCard/children/RecommendationsPage')))
const TreatmentPlansPage = Loadable(lazy(() => import('pages/medCard/children/TreatmentPlansPage')))
const TreatmentPlanDetailsPage = Loadable(lazy(() => import('pages/medCard/children/TreatmentPlanDetailsPage')))
const DianappPage = Loadable(lazy(() => import('pages/medCard/children/DianappPage')))
const DiagnocatPage = Loadable(lazy(() => import('pages/medCard/children/DiagnocatPage')))

// myAppointments
const MyAppointmentsPage = Loadable(lazy(() => import('pages/myAppointments/MyAppointmentsPage')));
const AppointmentDetailsPage = Loadable(lazy(() => import('pages/myAppointments/children/AppointmentDetailsPage')))

// fdoc
const FDocPage = Loadable(lazy(() => import('pages/fdoc/FDocPage')));

// materials
const MaterialsPage = Loadable(lazy(() => import('pages/materials/MaterialsPage')));

// promotions
const PromotionsPage = Loadable(lazy(() => import('pages/promotions/PromotionsPage')));
const DetailsPromotionsPage = Loadable(lazy(() => import('pages/promotions/children/DetailsPromotionsPage')));

// contacts 
const ContantPage = Loadable(lazy(() => import('pages/contacts/ContactsPage')));
const ClinicPage = Loadable(lazy(() => import('pages/contacts/children/ClinicPage')));

// cardDoctor
const CardDoctorPage = Loadable(lazy(() => import('pages/cardDoctor/СardDoctorPage')));

// profile
const ProfilePage = Loadable(lazy(() => import('pages/profile/ProfilePage')));

// myFamily
const MyFamilyPage = Loadable(lazy(() => import('pages/myFamily/MyFamilyPage')));

// DetailsAnalysisResPage
const DetailsAnalysisResPage = Loadable(lazy(() => import('pages/medCard/children/DetailsAnalysisResPage')));

// ChatFeedback
const ChatFeedbackPage = Loadable(lazy(() => import('pages/chatFeedback/ChatFeedbackPage')));

// Services
const ServicesPage = Loadable(lazy(() => import('pages/services/ServicesPage')));

// Payment
const PaymentPage = Loadable(lazy(() => import('pages/payment/PaymentPage')));

// Basket
const BasketPage = Loadable(lazy(() => import('pages/basket/BasketPage')));

// NotFoundPage
const NotFoundPage = Loadable(lazy(() => import('pages/notFoundPage/NotFoundPage')));

// ============ СТРАНИЦЫ ОНЛАЙН ЗАПИСИ (ВНЕ ЛК) ============
const AppointmentPage = Loadable(lazy(() => import('pages/appointmentOnline/AppointmentPage')));
const AuthCode = Loadable(lazy(() => import('pages/appointmentOnline/AuthCode')));
const PatientDataEntry = Loadable(lazy(() => import('pages/appointmentOnline/PatientDataEntry')));
const PatientSelection = Loadable(lazy(() => import('pages/appointmentOnline/PatientSelection')));
const SuccessPage = Loadable(lazy(() => import('pages/appointmentOnline/SuccessPage')));

// Admin
const AdminLayout = Loadable(lazy(() => import('pages/admin/AdminLayout')));
const AdminOverviewPage = Loadable(lazy(() => import('pages/admin/AdminOverviewPage')));
const AdminUsersPage = Loadable(lazy(() => import('pages/admin/AdminUsersPage')));
const AdminAppointmentsPage = Loadable(lazy(() => import('pages/admin/AdminAppointmentsPage')));
const AdminMedicalPage = Loadable(lazy(() => import('pages/admin/AdminMedicalPage')));
const AdminTechPage = Loadable(lazy(() => import('pages/admin/AdminTechPage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  // ОСНОВНЫЕ СТРАНИЦЫ ЛК (ТРЕБУЮТ АВТОРИЗАЦИЮ)
  children: [
    {
      path: '/',
      element: (
        <RequireVerified>
          <DashboardLayout/>
        </RequireVerified>
      ),
      children: [
        {
          index: true,
          element: <Navigate to='/main' replace/>
        },
        {
          path: '/main',
          element: <MainPage />
        },
        {
          path: '/makeAppointment',
          element: <MakeAppointmentPage />,
          children: [
            {
              path: '/makeAppointment/direction',
              element: <AppointmentByDirectionPage/>
            },
            {
              path: '/makeAppointment/free',
              element: <FreeAppointmentPage/>
            }
          ]
        },
        {
          path: '/medCard',
          element: <MedCardPage />,
          children: [
            {
              path: '/medCard/analysisResults',
              element: <AnalysisResultPage />
            },
            {
              path: '/medCard/hospitalizations',
              element: <HospitalizationsPage />
            },
            {
              path: '/medCard/researches',
              element: <ResearchPage /> 
            },
            {
              path: '/medCard/examinations',
              element: <ExaminationPage/>
            },
            {
              path: '/medCard/directions',
              element: <DirectionPage />
            },
            {
              path: '/medCard/recipes',
              element: <RecipePage />
            },
            {
              path: '/medCard/analysisResults/DetailsAnalysisResPage/:id',
              element: <DetailsAnalysisResPage />
            },
            {
              path: '/medCard/recommendations',
              element: <RecommendationsPage />
            },
            {
              path: '/medCard/treatmentPlans',
              element: <TreatmentPlansPage />
            },
            {
              path: '/medCard/treatmentPlans/:id',
              element: <TreatmentPlanDetailsPage />
            },
            {
              path: '/medCard/dianapp',
              element: <DianappPage />
            },
            {
              path: '/medCard/diagnocat',
              element: <DiagnocatPage />
            },
          ]
        },
        {
          path: '/myAppointments',
          element: <MyAppointmentsPage />,
          children: [
            {
              path: '/myAppointments/:id',
              element: <AppointmentDetailsPage />
            }
          ]
        },
        {
          path: '/fdoc',
          element: <FDocPage />
        },
        {
          path: '/materials',
          element: <MaterialsPage />
        },
        {
          path: '/promotions',
          element: <PromotionsPage />,
          children: [
            {
              path: '/promotions/:id',
              element: <DetailsPromotionsPage />
            }
          ]
        },
        {
          path: '/contacts',
          element: <ContantPage />,
          children: [
            {
              path: '/contacts/:id',
              element: <ClinicPage />
            }
          ]
        },
        {
          path: '/cardDoctor/:id',
          element: <CardDoctorPage />
        },
        {
          path: '/profile',
          element: <ProfilePage />
        },
        {
          path: '/myFamily',
          element: <MyFamilyPage />
        },
        {
          path: '/chatFeedback',
          element: projectConfig.feedback ? <ChatFeedbackPage /> : <NotFoundPage/>
        },
        {
          path: '/services',
          element: projectConfig.payment ? <ServicesPage /> : <NotFoundPage/>
        },
        {
          path: '/payment',
          element: projectConfig.payment ? <PaymentPage /> : <NotFoundPage/>
        },
        {
          path: '/basket',
          element: projectConfig.payment ? <BasketPage /> : <NotFoundPage/>
        },
        {
          element: <AdminRoute />,
          children: [
            {
              path: '/admin',
              element: <AdminLayout />,
              children: [
                  {
                      path: '/admin',
                      element: <AdminOverviewPage />,
                  },
                  {
                      path: '/admin/users',
                      element: <AdminUsersPage />,
                  },
                  {
                      path: '/admin/appointments',
                      element: <AdminAppointmentsPage />,
                  },
                  {
                      path: '/admin/medical',
                      element: <AdminMedicalPage />,
                  },
                  {
                      path: '/admin/tech',
                      element: <AdminTechPage />,
                  },
              ],
            },
          ],
        },
      ]
    },
    // ============ СТРАНИЦЫ ОНЛАЙН ЗАПИСИ (БЕЗ АВТОРИЗАЦИИ) ============
    {
      path: '/appointment',
      element: <AppointmentPage />,
      children: [
        {
          index: true,
          element: <AuthCode />,
        },
        {
          path: '/appointment/patient-selection',
          element: <PatientSelection />,
        },
        {
          path: '/appointment/patient-data',
          element: <PatientDataEntry />,
        },
        {
          path: '/appointment/success',
          element: <SuccessPage />,
        },
      ],
    }
  ]
};

export default MainRoutes;